var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139:2605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4911 10.2311C20.4703 12.2271 21.9515 13.3409 23.0672 14.0032C24.2136 14.6827 24.5987 15.1185 24.5943 15.7261C24.5852 16.6561 23.6798 17.0664 22.8321 17.0824C21.3531 17.1104 20.4933 16.5961 19.8096 16.2071L19.2769 19.2436C19.9628 19.6287 21.2328 19.9645 22.5498 19.9792C25.6412 19.9792 27.6637 18.1204 27.6747 15.2384C27.6867 11.5809 23.5212 11.3783 23.5496 9.74341C23.5594 9.24777 23.9478 8.71874 24.7988 8.58418C25.22 8.51629 26.3828 8.46426 27.7009 9.20372L28.2183 6.26581C27.5095 5.95133 26.5982 5.65015 25.4639 5.65015C22.5542 5.65015 20.5076 7.53421 20.4911 10.2311ZM33.1901 5.90329C32.6256 5.90329 32.1498 6.30442 31.9376 6.91998L27.5215 19.7633H30.6107L31.2254 17.694H35.0004L35.357 19.7633H38.0797L35.7037 5.90329H33.1901ZM33.6221 9.64745L34.5136 14.8519H32.0721L33.6221 9.64745ZM16.7457 5.90329L14.3107 19.7633H17.2543L19.6882 5.90329H16.7457ZM12.3909 5.90329L9.3269 15.3369L8.08751 7.31567C7.94206 6.42034 7.36777 5.90329 6.72999 5.90329H1.72116L1.65112 6.30575C2.67941 6.57753 3.84767 7.01594 4.55539 7.48496C4.98853 7.77138 5.1122 8.02186 5.25436 8.70276L7.60182 19.7633H10.7129L15.4822 5.90329H12.3909Z",
    fill: "#1A1F71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139:2605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/icon-visa.17959762.svg";
export { ForwardRef as ReactComponent };